export default __webpack_public_path__ + "static/media/Slide11.f1fe2b53.jpg";